var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "16",
        "height": "16",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('path', {
      attrs: {
        "d": "M12.341 11.147c-.888-.34-1.73-.777-2.706.134-.603.562-1.038.5-1.432.291-.394-.209-2.819-2.685-3.15-3.495-.331-.81-.152-.92 0-1.165.152-.246 1.208-.819.573-2.621-.636-1.802-1.135-3.16-3.723 0-.268.328 0 1.748 0 1.748s1.825 5.965 8.018 8.446c.961.385 3.132-.225 4.009-1.748.43-.746-.194-1.056-1.589-1.59z",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    })]));
  }
};